import {
  MonitoringExpirationSettings,
  MonitoringScheduleSettings,
  MonitoringThresholdsTicketSettings,
  SchedulingSettings,
  RecordingSettings,
  SettingsPropertyGroup,
  GeneralSettings,
  ElogSettings,
  SupportSettings,
} from "./types";
import {
  AssetTypes,
  getSettings,
  putSettings,
  putBuilder,
  getBuilder,
} from "./utils";

export const getMonitoringScheduleProperties = getBuilder(
  async (asset?: `/${AssetTypes}/${string}`) =>
    await getSettings<MonitoringScheduleSettings>(
      SettingsPropertyGroup.MonitoringSchedule,
      asset
    )
);
export const putMonitoringScheduleProperties = putBuilder(
  async (
    data: MonitoringScheduleSettings,
    asset?: `/${AssetTypes}/${string}`
  ) => await putSettings(data, SettingsPropertyGroup.MonitoringSchedule, asset)
);

export const getMonitoringThresholdsExpirationProperties = getBuilder(
  async (asset?: `/${AssetTypes}/${string}`) =>
    await getSettings<MonitoringExpirationSettings>(
      SettingsPropertyGroup.MonitoringExpiration,
      asset
    )
);
export const putMonitoringThresholdsExpirationProperties = putBuilder(
  async (
    data: MonitoringExpirationSettings,
    asset?: `/${AssetTypes}/${string}`
  ) =>
    await putSettings(data, SettingsPropertyGroup.MonitoringExpiration, asset)
);

export const getMonitoringThresholdsTicketsProperties = getBuilder(
  async (asset?: `/${AssetTypes}/${string}`) =>
    await getSettings<MonitoringThresholdsTicketSettings>(
      SettingsPropertyGroup.MonitoringThresholds,
      asset
    )
);

export const putMonitoringThresholdsTicketsProperties = putBuilder(
  async (
    data: MonitoringThresholdsTicketSettings,
    asset?: `/${AssetTypes}/${string}`
  ) =>
    await putSettings(data, SettingsPropertyGroup.MonitoringThresholds, asset)
);

export const getSchedulingProperties = getBuilder(
  async (asset?: `/${AssetTypes}/${string}`) =>
    await getSettings<SchedulingSettings>(
      SettingsPropertyGroup.Scheduling,
      asset
    )
);
export const putSchedulingProperties = putBuilder(
  async (data: SchedulingSettings, asset?: `/${AssetTypes}/${string}`) =>
    await putSettings(data, SettingsPropertyGroup.Scheduling, asset)
);

export const getRecordingProperties = getBuilder(
  async (asset?: `/${AssetTypes}/${string}`) =>
    await getSettings<RecordingSettings>(SettingsPropertyGroup.Recording, asset)
);

export const putRecordingProperties = putBuilder(
  async (data: RecordingSettings, asset?: `/${AssetTypes}/${string}`) =>
    await putSettings(data, SettingsPropertyGroup.Recording, asset)
);

export const getGeneralSettings = getBuilder(
  async (asset?: `/${AssetTypes}/${string}`) =>
    await getSettings<GeneralSettings>(SettingsPropertyGroup.General, asset)
);
export const putGeneralSettings = putBuilder(
  async (data: GeneralSettings, asset?: `/${AssetTypes}/${string}`) =>
    await putSettings(data, SettingsPropertyGroup.General, asset)
);

export const getElogProperties = getBuilder(
  async (asset?: `/${AssetTypes}/${string}`) =>
    await getSettings<ElogSettings>(SettingsPropertyGroup.Elog, asset)
);

export const getSupportInformation = async () =>
  await getSettings<SupportSettings>(SettingsPropertyGroup.Support);

export const putSupportInformation = async (data: SupportSettings) =>
  await putSettings(data, SettingsPropertyGroup.Support);
